export const SCREEN_SIZES = {
	'xs': '375px',
	'sm': '640px',
	'md': '750px',
	'lg': '1024px',
	'xl': '1300px',
	'2xl': '1536px',
	'3xl': '1920px'
} as const
